"use client";
import DownloadIcon from "@mui/icons-material/Download";
import React from "react";
import SongRenameDialog from "~/components/audio/SongRenameDialog";
import type {
  GetSongActions,
  SongAction,
} from "~/components/audio/songActions.types";
import { customerSongsService } from "~/connectors/songs.connector";
import type { Song } from "~/types";


export const getAdminDemoSongActions: GetSongActions = (
  song: Song,
  { router, getState },
): SongAction[] => {
  const handleDownload = async () => {
    try {
      await customerSongsService.downloadSong(song.id);
    } catch (err) {
      console.error("Download error:", err);
      alert("Eroare la descărcarea fișierului");
    }
  };

  const handleRename = async (songId: string, title: string) => {
    try {
      await customerSongsService.renameSong(songId, title);
      getState().updateCurrentSong({ title });
    } catch (err) {
      console.error("Rename error:", err);
      alert("Eroare la schimbarea titlului");
    }
  };

  const handleEditDemo = () => {
    getState().setBigPlayerOpen(false);
    const slugOrId = (song as any).slug ?? song.id;
    router.push(`/admin/demos/edit/${slugOrId}`);
  };

  const actions: SongAction[] = [
    { panel: "lyrics", visible: !!song.lyrics },
    {
      buttonProps: {
        startIcon: React.createElement(DownloadIcon),
        children: "Descarcă",
        onClick: () => void handleDownload(),
      },
      visible: !!song.downloadable,
    },
    {
      inContextMenu: true,
      contextMenuLabel: "Schimbă titlul",
      DialogComponent: ({ song: s, onClose }) =>
        React.createElement(SongRenameDialog, {
          song: s,
          onClose,
          onSave: handleRename,
        }),
      visible: true,
    },
    {
      inContextMenu: true,
      contextMenuLabel: "Editează demo",
      onContextMenuClick: handleEditDemo,
      visible: true,
    },
  ];

  return actions;
};
